'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { getStateFromIsoDate, getIsoDateFromState } from '../../utils/datetimeUtils';
import debounce from 'react-utils/debounce';
import * as SimpleDate from 'UIComponents/core/SimpleDate';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIGrid from 'UIComponents/grid/UIGrid';
import UIGridItem from 'UIComponents/grid/UIGridItem';
import UIDateInput from 'UIComponents/dates/UIDateInput';
import UITimeInput from 'UIComponents/input/UITimeInput';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UITextInput from 'UIComponents/input/UITextInput';
const TYPING_TIMEZONE_REGEX = /^(?:[+-]|[+-]\d|[+-]\d\d|[+-]\d\d:|[+-]\d\d:\d|[+-]\d\d:\d\d)$/m;
const FINISHED_TIMEZONE_REGEX = /^[+-]\d\d:\d\d$/m;
const StyledGrid = styled(UIGrid).withConfig({
  displayName: "DateTimeInput__StyledGrid",
  componentId: "sc-1hvfk5b-0"
})(["&&{margin-left:0;margin-right:0;}"]);
const StyledGridItem = styled(UIGridItem).withConfig({
  displayName: "DateTimeInput__StyledGridItem",
  componentId: "sc-1hvfk5b-1"
})(["&&{padding-left:0;padding-right:0;}"]);
export default class DateTimeInput extends Component {
  constructor(props) {
    super(props);

    this.update = (state = {}) => {
      const existingValues = Object.assign({}, this.state, {}, state);
      const dateToSet = {
        date: existingValues.date || SimpleDate.now(),
        time: existingValues.time || 0,
        timezone: existingValues.timezone || '+00:00'
      };
      this.setState(dateToSet);
      const isoDate = getIsoDateFromState(dateToSet);
      this.props.onChange(isoDate);
    };

    this.onDateChange = ({
      target: {
        value
      }
    }) => {
      this.setState({
        date: value
      });
      this.update({
        date: value
      });
    };

    this.onTimeChange = ({
      target: {
        value
      }
    }) => {
      this.setState({
        time: value
      });
      this.update({
        time: value
      });
    };

    this.onTimeZoneChange = ({
      target: {
        value
      }
    }) => {
      if (value.match(TYPING_TIMEZONE_REGEX)) {
        this.setState({
          timezone: value
        });
      }

      this.debouncedValidateTimezoneAndUpdate();
    };

    this.validateTimezoneAndUpdate = () => {
      if (!this.state.timezone.match(FINISHED_TIMEZONE_REGEX)) {
        this.setState({
          timezoneError: true
        });
      } else {
        this.setState({
          timezoneError: false
        });
        this.update();
      }
    };

    this.state = Object.assign({}, getStateFromIsoDate(props.value), {
      timezoneError: false
    });
    this.debouncedValidateTimezoneAndUpdate = debounce(this.validateTimezoneAndUpdate, 500);
  }

  render() {
    const {
      disabled,
      id,
      readOnly
    } = this.props;
    return /*#__PURE__*/_jsxs(StyledGrid, {
      children: [/*#__PURE__*/_jsx(StyledGridItem, {
        className: "date-time-input",
        size: {
          xs: 12,
          lg: 4
        },
        children: /*#__PURE__*/_jsx(UIDateInput, {
          disabled: disabled,
          id: `${id}-date`,
          onChange: this.onDateChange,
          readOnly: readOnly,
          value: this.state.date
        })
      }), /*#__PURE__*/_jsx(StyledGridItem, {
        className: "date-time-input",
        size: {
          xs: 12,
          lg: 4
        },
        children: /*#__PURE__*/_jsx(UITimeInput, {
          disabled: disabled,
          id: `${id}-time`,
          onChange: this.onTimeChange,
          readOnly: readOnly,
          value: this.state.time
        })
      }), /*#__PURE__*/_jsx(StyledGridItem, {
        className: "date-time-input",
        size: {
          xs: 12,
          lg: 4
        },
        children: /*#__PURE__*/_jsx(UIFormControl, {
          "aria-label": I18n.text('developer-docs-shared-components.params.body.dateTime.timezoneLabel'),
          className: "width-100",
          error: this.state.timezoneError,
          validationMessage: this.state.timezoneError ? /*#__PURE__*/_jsx(FormattedMessage, {
            message: "developer-docs-shared-components.params.body.dateTime.timezoneValidationError"
          }) : null,
          children: /*#__PURE__*/_jsx(UITextInput, {
            onBlur: this.validateTimezoneAndUpdate,
            onChange: this.onTimeZoneChange,
            placeholder: "+00:00",
            value: this.state.timezone
          })
        })
      })]
    });
  }

}
DateTimeInput.propTypes = {
  disabled: PropTypes.bool,
  id: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  readOnly: PropTypes.bool,
  value: PropTypes.string
};